export function dataInRequest(params = {}) {
  return {
    type: '@perfil/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@perfil/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@perfil/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@perfil/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@perfil/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@perfil/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@perfil/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@perfil/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@perfil/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@perfil/RECORD_FILTERING',
    payload: { params },
  };
}
